import type { InvoiceStyleTokens } from "./createInvoiceStyleTokens";

export const createBodyTextSx = (styleTokens: InvoiceStyleTokens) => ({
  color: styleTokens.colors.body,
  fontSize: 12,
  fontWeight: 700,
  lineHeight: 1.5,
});

export const createCompanyNameSx = (styleTokens: InvoiceStyleTokens) => ({
  color: styleTokens.colors.title,
  fontFamily: styleTokens.typography.headingFontFamily,
  fontSize: 15,
  fontWeight: 900,
  lineHeight: 1.5,
  overflowWrap: "anywhere",
});
